import React, { FC } from 'react';
import { SdkCodeSnippetsAsync } from '@cld/sdk-code-snippets';
import { useRecipeContentContext } from '../RecipeContentContext';

export interface ImageRendererProps {
  src: string;
  alt: string;
}

export const AssetRenderer: FC<React.PropsWithChildren<ImageRendererProps>> = ({ src, alt, ...rest }) => {
  const { copyCallback } = useRecipeContentContext();

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      {/\/video\//.exec(src) ? <video controls loop src={src} {...rest} /> : <img src={src} alt={alt} {...rest} />}
      <SdkCodeSnippetsAsync url={src} onCopy={copyCallback} />
    </>
  );
};
